// @flow
import { httpGet, httpPost } from '../helpers/helpers.api';
const endpoint = '/heating-notifications';

export function get(): Promise<Response> {
    return httpGet(endpoint);
}

export function save(
    id: string,
    coldEnabled: boolean,
    coldTemperature: number,
    hotEnabled: boolean,
    hotTemperature: number
): Promise<Response> {
    const payload = {
        hot: {
            enabled: hotEnabled,
            temperature: hotTemperature
        },
        cold: {
            enabled: coldEnabled,
            temperature: coldTemperature
        }
    };

    return httpPost(`${endpoint}/${id}`, payload);
}



// WEBPACK FOOTER //
// ./src/core/api/notifications/notifications.api.js